<template>
  <div class="text-center">
    <v-row class="mx-auto" justify="center">
      <v-col cols="12" sm="12" md="8" lg="6">
        <v-img
          v-if="language == 'en'"
          src="https://www.reg.kmitl.ac.th/storage/reg/FlowChartPreRegisTH01.jpg"
        ></v-img>
        <v-img
          v-else
          src="https://www.reg.kmitl.ac.th/storage/reg/FlowChartPreRegisTH01.jpg"
        ></v-img>
      </v-col>
    </v-row>
    <v-row class="mx-auto" justify="center">
      <v-col cols="12" sm="12" md="10" lg="6">
        <v-btn
          large
          dark
          color="teal darken-2"
          elevation="5"
          class="justify-center ml-5"
          v-on:click="clickNext"
          >{{ $t("pre_regis_flow_chart.next") }}</v-btn
        >
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "PreRegisFlowChart",
  props: {
    clickNext: {
      type: Function,
    },
  },
  computed: {
    language() {
      return this.$root.$i18n.locale;
    },
  },
};
</script>
